var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"go-back__icon rotate--270"},[_c('IconArrowTop',{attrs:{"width":"21","height":"12"}})],1),_c('h3',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }